import type { ReactNode } from 'react';
import { cn } from '@/lib/cn.js';

export function Card({ className, children }: { className?: string; children: ReactNode }) {
  return <section className={cn('border border-n-200 bg-white', className)}>{children}</section>;
}

/** Maketda panel sarlavhasi 15px, ostida INGICHKA chiziq (`D2`, `D3`). */
export function CardHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <header className="flex items-start justify-between gap-4 border-b border-n-100 px-5 py-4">
      <div>
        <h2 className="text-[15px] font-semibold text-n-900">{title}</h2>
        {description && <p className="mt-0.5 text-sm text-n-600">{description}</p>}
      </div>
      {action}
    </header>
  );
}

export function CardBody({ className, children }: { className?: string; children: ReactNode }) {
  return <div className={cn('px-5 py-4', className)}>{children}</div>;
}

/**
 * Sahifa sarlavhasi — MAKETDAN (`D2`, `D3`, `D5`): 26px sarlavha,
 * ostida nechta yozuv topilgani, o'ng chekkada amallar.
 */
export function PageHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="mb-[18px] flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
      <div>
        <h1 className="text-[26px] font-semibold tracking-[-0.02em] text-n-900">{title}</h1>
        {description && <p className="mt-1.5 text-[13.5px] text-n-600">{description}</p>}
      </div>
      {action}
    </div>
  );
}
